import React from 'react';

export const ServiceProductInfo = ({
    handleChange,
    isEditable,
    formData,
    handleSaveFields,
    setIsEditable,
}) => {
    return (
        <div className='p-4 border border-gray-300 rounded-lg'>
            <div className='flex space-x-4'>
                {isEditable ? (
                    <>
                        <div>
                            <label className='block text-sm font-medium text-gray-700'>
                                Varemerke:
                            </label>
                            <input
                                type='text'
                                name='Varemerke'
                                value={formData.Varemerke}
                                onChange={handleChange}
                                className='mt-1 block w-full p-2 border border-gray-300 rounded-md'
                            />
                        </div>
                        <div>
                            <label className='block text-sm font-medium text-gray-700'>
                                Produkt:
                            </label>
                            <input
                                type='text'
                                name='Produkt'
                                value={formData.Produkt}
                                onChange={handleChange}
                                className='mt-1 block w-full p-2 border border-gray-300 rounded-md'
                            />
                        </div>
                    </>
                ) : (
                    <div className='flex gap-4'>
                        <p>
                            <span className='font-bold'>Varemerke:</span> {formData.Varemerke}
                        </p>
                        <p>
                            <span className='font-bold'>Produkt:</span> {formData.Produkt}
                        </p>
                    </div>
                )}
            </div>

            <div className='flex space-x-4'>
                {isEditable ? (
                    <>
                        <div>
                            <label className='block text-sm font-medium text-gray-700'>
                                Størrelse:
                            </label>
                            <input
                                type='text'
                                name='Størrelse'
                                value={formData.Størrelse}
                                onChange={handleChange}
                                className='mt-1 block w-full p-2 border border-gray-300 rounded-md'
                            />
                        </div>
                        <div>
                            <label className='block text-sm font-medium text-gray-700'>
                                Farge:
                            </label>
                            <input
                                type='text'
                                name='Farge'
                                value={formData.Farge}
                                onChange={handleChange}
                                className='mt-1 block w-full p-2 border border-gray-300 rounded-md'
                            />
                        </div>
                    </>
                ) : (
                    <div className='flex gap-4'>
                        <p>
                            <span className='font-bold'>Størrelse:</span> {formData.Størrelse}
                        </p>
                        <p>
                            <span className='font-bold'>Farge:</span> {formData.Farge}
                        </p>
                    </div>
                )}
            </div>
            <button
                type='button'
                onClick={async () => {
                    console.log('Lukker redigeringsmodus...');
                    if (isEditable) {
                        console.log('Oppdaterer produktinfo før lukking...');
                        await handleSaveFields(); // Lagre feltene når redigeringsmodus lukkes
                    }
                    setIsEditable(!isEditable); // Lukk redigeringsmodus
                }}
                className='text-blue-500 hover:underline'
            >
                {isEditable ? 'Lukk redigeringsmodus' : 'Rediger'}
            </button>
        </div>
    );
};
